var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCaretUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3918 9.1043C11.3918 9.10428 11.3918 9.10432 11.3918 9.1043L8.05974 5.77121C8.05968 5.77115 8.0598 5.77127 8.05974 5.77121C8.02687 5.73861 7.97366 5.73843 7.94079 5.77103C7.94085 5.77097 7.94073 5.77109 7.94079 5.77103L4.60852 9.1043C4.60858 9.10424 4.60847 9.10435 4.60852 9.1043C4.58459 9.12842 4.5773 9.16471 4.5903 9.19612C4.6033 9.22752 4.63385 9.24804 4.66781 9.24821L11.3325 9.24821C11.3665 9.24804 11.3971 9.22752 11.41 9.19612C11.4231 9.16467 11.4158 9.12842 11.3918 9.1043ZM3.54656 8.04494C3.0946 8.49801 2.95959 9.17849 3.20434 9.76979C3.44909 10.3611 4.02553 10.7471 4.66548 10.7482L11.3336 10.7482L11.3349 10.7482C11.9748 10.7471 12.5513 10.3611 12.796 9.7698C13.0408 9.17849 12.9057 8.49801 12.4538 8.04494L9.1191 4.70925C8.50069 4.09236 7.49966 4.09236 6.88125 4.70925L3.54656 8.04494Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCaretUp);
export default __webpack_public_path__ + "static/media/icon-caret-up.271c05e713b496ff0bd952599a112dfe.svg";
export { ForwardRef as ReactComponent };